<div class="row mt-4" id="message1">
    <div class="col-12 col-lg-9 pt-4 detail-box">
        <div class="message-detail">
            <h3>Principal's Message</h3>
            <p class="text-left">I am proud to have been associated with Maharana Pratap Public School, Kurukshetra right from its inception in 1992; and to have been the Principal since 1995.</p>
            <p class="text-left">I look back with immense satisfaction at what we have achieved over the years; and look forward with tremendous hope at our potential to achieve so much more in future.
                 We strongly believe that our achievements are a result of the commitment and perseverance we bring to bear on everything we do.
                  We are confident that we will continue on the same path with greater vigor and intensity.
                   Education for us goes beyond the mundane practice of teaching and learning that leads to acquiring a qualification; we take it as a mission to shape the future of individual students and through them, the future of our society and the nation.
                 I call upon all the stakeholders to extend a helping hand in achieving the lofty goals we have set for ourselves. </p>
            <p class="d-block d-md-none mb-0">Annie Philip</p>
            <p class="d-block d-md-none">Principal</p>
          </div>
    </div>
    <div class="col-12 col-lg-3 d-none d-md-block image-box">
        <div class="badge1 badge">
            <div class="text">
                Annie Philip
            </div>
        </div>
    </div>
    <div class="col-12 d-block d-md-none text-center image-box">
        <img src="/assets/img/message/1.jpg" alt="Principal" class="img-fluid rounded-circle" loading='eager'>
    </div>
</div>